import { Validator } from '@vista-digital/validator';
/**
 * Determines the ticketing mode.
 */
export var TicketingMode;
(function (TicketingMode) {
    /**
     * In seat-first ordering mode the patron will select their seats before selecting their tickets.
     */
    TicketingMode["SeatFirst"] = "SeatFirst";
    /**
     * In ticket-first ordering mode the patron will select their tickets before selecting their seats.
     */
    TicketingMode["TicketFirst"] = "TicketFirst";
})(TicketingMode || (TicketingMode = {}));
export const ticketingModeValidator = Validator.oneOf(Object.values(TicketingMode));
